// Bold type letter (D/G), coloured by the operator's receiveMessage status.
.type-letter {
  color: var(--color-text-muted);
  flex-shrink: 0;
  font-weight: 800;
}

.rm-allowed {
  color: var(--color-success, #22c55e);
}

.rm-prep {
  color: var(--color-warning-dot, #eab308);
}

.rm-blocked {
  color: var(--color-danger, #ef4444);
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rating {
  align-items: center;
  color: var(--color-foreground);
  display: inline-flex;
  flex-shrink: 0;
  font-weight: 700;
  gap: 2px;
}

.star {
  color: var(--color-warning-dot, #eab308);
  fill: currentColor;
  height: 12px;
  width: 12px;
}

.assigned {
  color: var(--color-danger, #ef4444);
  flex-shrink: 0;
  font-weight: 600;
}

.edit-button {
  align-items: center;
  background: none;
  border: 0;
  color: var(--color-text-muted);
  cursor: pointer;
  display: inline-flex;
  padding: 4px;

  &:hover {
    color: var(--color-foreground);
  }
}
